import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { StaffEmailSignatureView } from '../components/views/staffEmailSignatureView'

function StaffEmailSignature() {
    return (
        <div className="staffEmailSignature">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Sentinel Tools"
                        title="Staff Email Signature"
                        intro="Enter your name and title, then copy the HTML straight into your email client signature settings."
                    />
                    <StaffEmailSignatureView />
                </Page>
            </MainView>
        </div>
    )
}

export default StaffEmailSignature
